"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleContainer = exports.featureSwitches = exports.buttons = void 0;
exports.buttons = {
    staging: "set-to-staging",
    production: "set-to-production",
    dev: "set-to-dev",
};
const featureSwitches = (featureName) => `${featureName}-feature-switch-value`;
exports.featureSwitches = featureSwitches;
exports.toggleContainer = "container-feature-switch";
